﻿export default window._;